module.exports = __webpack_public_path__ + "img/playkids-logo-black.29511b6e.png";